// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"cf68825a","239":"f3507dac","407":"871d95b5"}[chunkId] + ".chunk.css";
};